import { NSARouterMakerResult } from 'namirasoft-account-react';
import { Component, createRef } from 'react';
import QuestionGroupForm from './QuestionGroupForm';
import { PasswordQuestion } from '../PasswordQuestion';

export interface QuestionsFormProps extends NSARouterMakerResult
{
    questions: string[];
    visibleGroup?: number | null;
}

export interface QuestionsFormState
{
    questions: string[];
    extra: string[];
}

export class QuestionsForm extends Component<QuestionsFormProps, QuestionsFormState>
{
    static GROUP_SIZE = 4;
    static GROUP_COUNT = 3;

    private groups = new Array(QuestionsForm.GROUP_COUNT).fill(0).map(() => createRef<QuestionGroupForm>());
    private pendingClears: number[] = [];

    constructor(props: QuestionsFormProps)
    {
        super(props);
        this.state = {
            questions: props.questions,
            extra: PasswordQuestion.EXTRA.filter((q) => !props.questions.includes(q)),
        };
        this.getValue = this.getValue.bind(this);
        this.getGroupValue = this.getGroupValue.bind(this);
        this.getLockedQuestions = this.getLockedQuestions.bind(this);
        this.handleApplyQuestion = this.handleApplyQuestion.bind(this);
    }

    getGroupValue(groupIndex: number, checkError?: boolean): { questions: string[], answers: string[] }
    {
        let start_index = groupIndex * QuestionsForm.GROUP_SIZE;
        let questions = this.state.questions.slice(start_index, start_index + QuestionsForm.GROUP_SIZE);
        let answers = this.groups[groupIndex].current?.getAnswers(checkError) ?? [];
        return { questions, answers };
    }

    getValue(checkError: boolean = false): { questions: string[], answers: string[] }
    {
        let questions: string[] = [];
        let answers: string[] = [];
        for (let i = 0; i < this.groups.length; i++)
        {
            let value = this.getGroupValue(i, checkError);
            questions.push(...value.questions);
            answers.push(...value.answers);
        }
        return { questions, answers };
    }

    getLockedQuestions(groupIndex: number): string[]
    {
        return this.state.questions.slice(0, (groupIndex + 1) * QuestionsForm.GROUP_SIZE);
    }

    handleApplyQuestion(groupIndex: number, localIndex: number, newQuestion: string): void
    {
        let GROUP_SIZE = QuestionsForm.GROUP_SIZE;
        let globalIndex = groupIndex * GROUP_SIZE + localIndex;
        let futureStart = (groupIndex + 1) * GROUP_SIZE;

        this.setState((prev) =>
        {
            let questions = [...prev.questions];
            questions[globalIndex] = newQuestion;
            let extra = prev.extra.filter((q) => q !== newQuestion);

            let clears: number[] = [globalIndex];
            for (let j = futureStart; j < questions.length; j++)
            {
                if (questions[j] === newQuestion && extra.length > 0)
                {
                    questions[j] = extra[0];
                    extra = extra.slice(1);
                    clears.push(j);
                }
            }

            this.pendingClears = clears;
            return { questions, extra };
        }, () =>
        {
            for (let j of this.pendingClears)
            {
                let group = Math.floor(j / GROUP_SIZE);
                let local = j % GROUP_SIZE;
                this.groups[group].current?.clearAnswer(local);
            }
            this.pendingClears = [];
        });
    }

    override render()
    {
        let { visibleGroup } = this.props;
        return (
            <>
                {
                    this.groups.map((ref, index) =>
                    {
                        let start_index = index * QuestionsForm.GROUP_SIZE;
                        let visible = visibleGroup == null || visibleGroup === index;
                        return (
                            <div key={index} style={{ display: visible ? "contents" : "none" }}>
                                <QuestionGroupForm
                                    ref={ref}
                                    {...this.props}
                                    start_index={start_index}
                                    questions={this.state.questions.slice(start_index, start_index + QuestionsForm.GROUP_SIZE)}
                                    getExtraQuestions={() => this.state.extra}
                                    getLockedQuestions={() => this.getLockedQuestions(index)}
                                    onApplyQuestion={(localIndex, newQuestion) => this.handleApplyQuestion(index, localIndex, newQuestion)}
                                />
                            </div>
                        );
                    })
                }
            </>
        );
    }
}

export default QuestionsForm;